import {call, put} from "redux-saga/effects";
import {getErrorFromMessage} from "services/utils/utils";
import * as api from "services/api";
import {upsertThreadFail, upsertThreadSuccess} from "store/reducer/threads/upsert/reducer";
import {historyObject} from "historyObject";

export function* upsertThreadSaga({payload}) {
    try {
        const thread = yield call([api, api.threadUpsertApi], payload);
        console.log("RESPONSE", thread);
        yield put(upsertThreadSuccess());
        yield call(historyObject.push, `/threads/${thread ? thread.id : payload.id}`);
    } catch (e) {
        console.log(e);
        yield put(upsertThreadFail(getErrorFromMessage(e)));
    }
}